import { Directive, ElementRef, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneMask]'
})
export class PhoneMaskDirective {
  private previousValue = '';

  constructor(
    private el: ElementRef,
    @Self() private ngControl: NgControl
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    // Get only digits from input
    let value = event.target.value.replace(/\D/g, '');
    
    // Limit to 10 digits
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    // Set the raw digits in the form control (for validation)
    if (this.ngControl.control) {
      this.ngControl.control.setValue(value, { emitEvent: false });
    }

    // Format for display
    let formattedValue = '';
    
    if (value.length === 0) {
      formattedValue = '';
    } else if (value.length <= 3) {
      formattedValue = `(${value}`;
    } else if (value.length <= 6) {
      formattedValue = `(${value.substring(0, 3)}) ${value.substring(3)}`;
    } else {
      formattedValue = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`;
    }

    // Update the input display value
    this.el.nativeElement.value = formattedValue;
    this.previousValue = formattedValue;
  }

  @HostListener('blur')
  onBlur(): void {
    const value = this.ngControl.control?.value || '';
    
    // Format on blur if we have exactly 10 digits
    if (value.length === 10) {
      this.el.nativeElement.value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`;
    } else if (value.length === 0) {
      this.el.nativeElement.value = '';
    }
  }

  @HostListener('focus')
  onFocus(): void {
    // Optional: keep formatted on focus, or you can clear formatting here
    const value = this.ngControl.control?.value || '';
    if (value.length > 0 && value.length < 10) {
      // Show partial formatting while typing
      this.onInput({ target: { value: this.el.nativeElement.value } });
    }
  }
}